import React from 'react';
import { Form } from 'antd';

export default function getEditableFormRow(Context) {
  const EditableRow = ({ form, index, ...props }) => {
    return (
      <Context.Provider value={form}>
        <tr {...props} />
      </Context.Provider>
    );
  };

  return Form.create()(EditableRow);
}
